// Get Master Reporting item list
export const GET_MASTER_REPORTING_ITEM_LIST = "GET_MASTER_REPORTING_ITEM_LIST";
export const GET_MASTER_REPORTING_ITEM_LIST_SUCCESS =
  "GET_MASTER_REPORTING_ITEM_LIST_SUCCESS";
export const GET_MASTER_REPORTING_ITEM_LIST_FAILURE =
  "GET_MASTER_REPORTING_ITEM_LIST_FAILURE";

// Get master reporting item data
export const GET_MASTER_REPORTING_ITEM_DATA = "GET_MASTER_REPORTING_ITEM_DATA";
export const GET_MASTER_REPORTING_ITEM_DATA_SUCCESS =
  "GET_MASTER_REPORTING_ITEM_DATA_SUCCESS";
export const GET_MASTER_REPORTING_ITEM_DATA_FAILURE =
  "GET_MASTER_REPORTING_ITEM_DATA_FAILURE";
